<template>
    <div>

        <div id="catalog--show" class="sale-product" v-if="item">
            <div class="container">

                <b-breadcrumb :items="breadcrumb" v-if="breadcrumb"></b-breadcrumb>

                <div class="row">
                    <div class="d-none d-xl-block col-xl-3">
                        <catalog-categories></catalog-categories>
                    </div>
                    <div class="col-xl-9 position-relative">
                        <div class="mb-40">

                            <div>
                                <div class="row justify-content-center mb-64 show-row">
                                    <div class="mb-5 mb-lg-0 col-10 col-sm-8 col-md-10 col-lg-6">
                                        <b-carousel
                                            id="carousel"
                                            :interval="0"
                                            fade
                                            v-model="slide"
                                            :controls="true ? item_images.length > 1 : false">
                                            <b-carousel-slide v-for="(image, i) in item_images" :key="i"
                                                              class="cursor-pointer"
                                                              v-b-modal.showProductImage>
                                                <template #img>
                                                    <img
                                                        class="d-block img-fluid w-100"
                                                        :src="'https://app.skybase.ru/public/actions/39947490820098?fileid=' + item.code + image"
                                                        :alt="item.name + ' взять в аренду в Фотопрокате MRental в Минске без залога.'"
                                                    >
                                                </template>
                                            </b-carousel-slide>
                                        </b-carousel>

                                        <div class="carousel-navigation">
                                            <div v-for="(image, i) in item_images" :key="i"
                                                 class="carousel-navigation__item"
                                                 :class="{'active': slide == i}"
                                                 @click="slideTo(i)">
                                                <img
                                                    :src="'https://app.skybase.ru/public/actions/39947490820098?fileid=' + item.code + image"
                                                    :alt="'Вы можете взять в аренду ' + item.name + ' на сервисе фотопроката MRental'"
                                                    class="img-fluid">
                                            </div>
                                        </div>


                                    </div>
                                    <div class="col-lg-6">
                                        <h1 class="as-h2 mb-20">{{item.name}}</h1>

                                        <div class="mb-12 small_desc d-md-block d-none" v-html="item.small_desc"></div>

                                        <div class="mb-12 small_desc d-md-block d-none" v-html="item.desc"></div>

                                        <div class="mb-12 small_desc d-md-block d-none" v-html="item.complement"></div>

                                        <div class="price-card mb-32">
                                            <div class="title-3 mb-0 d-flex align-items-center justify-content-between">
                                                <div class="title-3 font-500 mb-8">Стоимость продажи</div>
                                                <span
                                                    class="font-700 color-primary">{{item.base_price}} RUB </span>
                                            </div>
                                        </div>

                                        <div class="mb-12 small_desc d-block d-md-none" v-html="item.small_desc"></div>

                                        <div class="mb-12 small_desc d-block d-md-none" v-html="item.desc"></div>

                                        <div class="mb-12 small_desc d-block d-md-none" v-html="item.complement"></div>

                                        <button class="button btn-small" v-on:click="saleClick()">Купить</button>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- MODAL WITH IMAGES-->
            <b-modal id="showProductImage"
                     :hide-header="true"
                     :hide-footer="true">
                <div class="hide-area" @click="$bvModal.hide('showProductImage')"></div>
                <div class="close" @click="$bvModal.hide('showProductImage')"><img src="/svg/close.svg" alt=""></div>
                <div class="show-area">
                    <b-carousel
                        id="carouselModal"
                        :interval="0"
                        fade
                        v-model="slide"
                        :controls="true ? item_images.length > 1 : false">
                        <b-carousel-slide v-for="(image, i) in item_images" :key="i">
                            <template #img>
                                <img class="d-block img-fluid"
                                     :alt="'Вы можете взять в аренду' + item.name + 'на сервисе фотопроката MRental'"
                                     :src="'https://app.skybase.ru/public/actions/39947490820098?fileid=' + item.code + image">
                            </template>
                        </b-carousel-slide>
                    </b-carousel>
                </div>
            </b-modal>

            <div v-if="loading" class="loading-box">
                <b-spinner></b-spinner>
            </div>
        </div>

    </div>
</template>

<script>
    import store from '../../../services/data';
    import filter from "../../../services/filter";

    import carousel from 'vue-owl-carousel'

    export default {
        components: {carousel},

        data() {
            return {
                breadcrumb: null,

                item: null,
                item_images: null,

                store: store,
                filter: filter,

                count: 1,
                itemFromBasket: null,

                slide: 0,
                loading: true
            }
        },

        mounted() {
            this.init();
        },

        methods: {
            saleClick() {
                Swal.fire({
                    icon: 'success',
                    title: 'Продажа товара.',
                    html: `Для уточнения деталей и покупки товара свяжитесь с нами по номеру: <a href="tel:+79774097239">+7 977 409 72 39</a>.`,
                });
            },
            init() {
                this.loading = true;
                let url = '/api/product-sale-info';
                let params = {
                    url: this.$route.path
                };
                axios.post(url, params)
                    .then(response => {
                        this.item = response.data.product;
                        let seoInfo = response.data.seoInfo;

                        let images = [];
                        if (response.data.product.main_image) images.push('-f64');
                        if (response.data.product.image2) images.push('-f65');
                        if (response.data.product.image3) images.push('-f66');
                        this.item_images = images;

                        this.getBreadcrumb();
                        this.loading = false;

                        document.title = seoInfo?.seo_title ? seoInfo?.seo_title :  this.item.name + ' на продажу в Минске';

                        let desc = seoInfo?.seo_desc ? seoInfo?.seo_desc :  'Продажа ' + this.item.name + ' в Минске. &#9889; Продажа фото и видео техники и оборудования ☑ без залога ☑ доставка. Скидки &#9193;'

                        document.querySelector('meta[name="description"]').setAttribute("content", desc);
                        document.querySelector('meta[name="twitter:description"]').setAttribute("content", desc);
                        document.querySelector('meta[property="og:description"]').setAttribute("content", desc);
                        document.querySelector('meta[name="twitter:text:description"]').setAttribute("content", desc);
                    });
            },
            getBreadcrumb() {
                this.breadcrumb = [
                    {
                        text: 'Главная',
                        to: {name: 'pages-index'}
                    },
                    {
                        text: "Продажа",
                        to: {name: 'pages-sale'}
                    },
                    {
                        text: this.item.name
                    }
                ]
            },

            preventDefault(event) {
                if (event) event.preventDefault();
            },
            slideTo(item) {
                this.slide = item;
            },
            changeActive(item) {
                this.slide = item;
            }
        },

        watch: {
            $route() {
                this.item = null;
                this.item_images = null;

                this.init();
            }
        },
    }
</script>
